<template>
  <section id="slider" class="slideDown">
    <div class="back" @click="back()">{{ $t('admin.slider.back') }}</div>

    <div class="container">
      <div class="content">
        <h3 class="title">
          <span v-if="slider.id == -1">{{ $t('general.create') }}</span><span v-else>{{ $t('general.edit') }}</span
          ><span>{{ $t('admin.slider.front_page') }}</span>
        </h3>

        <div class="details">
          <div class="subtitle">{{ $t('general.subtitle') }}</div>
          <v-form ref="form_slider" v-model="valid">
            <v-text-field
              v-model="slider.name"
              :rules="requiredRules"
              :label="$t('general.name')"
              required
            ></v-text-field>
            <v-flex
              xs12
              class="text-xs-center text-sm-center text-md-center text-lg-center"
            >
              <!-- <img :src="imageUrl" height="150" v-if="fil"/> -->
              <div class="subtitle text-xs-left">
                {{ $t('admin.slider.size') }}
              </div>
              <v-text-field
                :rules="requiredRules"
                :label="$t('admin.slider.select_front_page')"
                @click.stop="pickFile"
                v-model="fileName"
                prepend-icon="library_add"
              ></v-text-field>
              <input
                type="file"
                style="display: none"
                ref="image"
                accept="*"
                @change="onFilePicked"
              />
            </v-flex>
            <div class="subtitle">{{ $t('general.categories') }}</div>
            <div>
              <v-card-title class="searcher">
                <v-text-field
                  class="input-searcher"
                  v-model="search"
                  append-icon="search"
                  :label="$t('general.search_category')"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                id="categories"
                :custom-filter="filterTable"
                :headers="headers"
                :items="sections"
                class=""
                :no-results-text="message_not_found"
                :rows-per-page-items="rowsPerPage"
                :search="search"
                :pagination.sync="pagination"
                :rows-per-page-text="message_rows_per_page"
              >
                <template v-slot:items="props">
                  <template v-if="props.item.level != 0">
                    <tr @click="choise(props.item)">
                      <td>
                        <v-checkbox
                          :input-value="props.item.url == url"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td style="text-align:left">
                        <div class="name">{{ props.item.name }}</div>
                        <div class="path">{{ props.item.path }}</div>
                      </td>
                    </tr>
                  </template>
                </template>
              </v-data-table>
            </div>
            <!-- <v-text-field :readonly="true" v-model="slider.url" :rules="requiredRules" label="Url" required></v-text-field> -->
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="start_date"
              persistent
              lazy
              full-width
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="start_date"
                  :label="$t('general.start_date')"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="start_date" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modal = false"
                  >{{ $t('general.cancel') }}</v-btn
                >
                <v-btn
                  flat
                  color="primary"
                  @click="dateSelect(start_date, 'start_date')"
                  >{{ $t('general.accept') }}</v-btn
                >
              </v-date-picker>
            </v-dialog>

            <v-dialog
              ref="dialog2"
              v-model="modal2"
              :return-value.sync="end_date"
              persistent
              lazy
              full-width
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="end_date"
                  :label="$t('admin.slider.end_date')"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                  id="end_date"
                ></v-text-field>
              </template>
              <v-date-picker v-model="end_date" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modal2 = false"
                  >{{ $t('general.cancel') }}</v-btn
                >
                <v-btn
                  flat
                  color="primary"
                  @click="dateSelect(end_date, 'end_date')"
                  >{{ $t('general.accept') }}</v-btn
                >
              </v-date-picker>
            </v-dialog>
            <v-switch v-model="slider.status" :label="$t('general.active')"></v-switch>
          </v-form>
        </div>

        <div class="buttons">
          <v-btn color="success" @click="save">{{ $t('general.save') }}</v-btn>
          <v-btn color="cancel" @click="back">{{ $t('general.back') }}</v-btn>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import i18n from '@/i18n';
export default {
  props: {},
  data() {
    return {
      slider: JSON.parse(
        JSON.stringify(this.$store.getters["sliders/getCurrentSlider"])
      ),
      valid: false,
      requiredRules: [v => !!v || i18n.t('general.obligatory_field')],
      fileName: JSON.parse(
        JSON.stringify(this.$store.getters["sliders/getCurrentSlider"])
      ).file,
      modal: false,
      modal2: false,
      start_date: JSON.parse(
        JSON.stringify(this.$store.getters["sliders/getCurrentSlider"])
      ).start_date,
      end_date: JSON.parse(
        JSON.stringify(this.$store.getters["sliders/getCurrentSlider"])
      ).end_date,
      url: JSON.parse(
        JSON.stringify(this.$store.getters["sliders/getCurrentSlider"])
      )
        .url.replace(window.location.origin, "")
        .replace(/\/(.*)\//g, ""),
      headers: [
        { text: "", value: "selected", width: "30px", class: "condensed" },
        { text: i18n.t('general.name'), value: "name", width: "100%" }
      ],
      search: "",
      search_type: "",
      message_not_found: i18n.t('general.message_not_found'),
      message_rows_per_page: i18n.t('general.message_rows_per_page'),
      rowsPerPage: [{ text: i18n.t('general.all'), value: -1 }],
      pagination: {
        sortBy: "name"
      },
      sectionTypes: {
        "1": { name: i18n.t('admin.section.section_types.national'), url: "nacional" },
        "2": { name: i18n.t('admin.section.section_types.local'), url: "local" },
        "3": { name: i18n.t('admin.section.section_types.support'), url: "comunicacion" },
        "5": { name: i18n.t('admin.section.section_types.communication'), url: "practices" }
      },
      select: []
    };
  },
  created() {
    var id = this.slider.id != -1 ? this.slider.id : "add";
    this.$router.push({ name: "sliders_edit", params: { id: id } });

    var self = this;
    this.$store.dispatch("files/loadCategories", {}).then(function() {
      self.$store.commit("files/selectCategory", false);
      self.slider.status = self.slider.status == "1";
    });
  },
  computed: {
    sections() {
      var sections = ObjectToArray(
        JSON.parse(JSON.stringify(this.$store.getters["files/getCategories"]()))
      );

      var aSections = [];
      sections.forEach(section => {
        var childs = ObjectToArray(section.childs);
        section.visible = true;
        section.childs = childs;
        section.level = parseInt(section.level);
        section.path = "";
        aSections.push(section);
        childs.forEach(child => {
          child.visible = child.visible || false;
          var childs2 = ObjectToArray(child.childs);
          child.childs = childs2;
          child.level = parseInt(child.level);
          child.path = section.name;
          aSections.push(child);
          childs2.forEach(child2 => {
            child2.visible = child2.visible || false;
            child2.level = parseInt(child2.level);
            child2.path = section.name + " > " + child.name;
            aSections.push(child2);
          });
        });
      });
      return aSections;
    },
    selected: {
      get: function() {
        return this.select;
      },
      set: function(sections) {
        this.select = sections;
      }
    }
  },
  methods: {
    back() {
      this.$store.commit("sliders/setCurrentSlider", false);
      this.$router.push({ name: "sliders" });
    },
    save() {
      if (this.$refs.form_slider.validate()) {
        var self = this;
        this.slider.start_date = this.start_date ? this.start_date : null;
        this.slider.end_date = this.end_date ? this.end_date : null;
        this.$store
          .dispatch("sliders/uploadSlider", this.slider)
          .then(function() {
            self.$store.commit("sliders/setCurrentSlider", false);
            self.$router.push({ name: "sliders" });
          });
      }
    },
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.fileName = files[0].name;
        this.slider.file = files[0];
      } else {
        this.fileName = "";
      }
    },
    choise(section) {
      if (this.url != "" && section.url == this.url) {
        this.url = undefined;
      } else {
        if (section.type == "5") {
          this.slider.url =
            window.location.origin +
            "/" +
            this.sectionTypes[section.type].url;
        } else {
          this.slider.url =
            window.location.origin +
            "/" +
            this.sectionTypes[section.type].url +
            "/" +
            section.url;
        }
        this.url = section.url;
      }
    },
    filterTable(items, search, filter) {
      var aItems = [];
      items.forEach(item => {
        if (
          filter(item.name, search.toLowerCase()) ||
          filter(item.path, search.toLowerCase())
        ) {
          aItems.push(item);
        } else {
          Object.values(item.childs).forEach(child => {
            if (
              filter(child.name, search.toLowerCase()) ||
              filter(child.path, search.toLowerCase())
            ) {
              aItems.push(item);
            } else {
              Object.values(child.childs).forEach(child2 => {
                if (
                  filter(child2.name, search.toLowerCase()) ||
                  filter(child2.path, search.toLowerCase())
                ) {
                  aItems.push(item);
                }
              });
            }
          });
        }
      });
      return aItems;
    },
    expand(id) {
      this.$store.commit("files/expandSection", id);
    },
    less(id) {
      this.$store.commit("files/lessSection", id);
    },
    changeUrl(section) {
      this.slider.url =
        window.location.origin +
        "/" +
        this.sectionTypes[section.type].url +
        "/" +
        section.url;
      this.url = this.slider.url;
    },
    dateSelect(date, mode) {
      switch (mode) {
        case "start_date":
          this.$refs.dialog.save(date);
          // this.$refs.end_date.click();
          let clickEvent = new Event("click");
          document.getElementById("end_date").dispatchEvent(clickEvent);
          break;
        case "end_date":
          this.$refs.dialog2.save(date);
          break;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.child {
  border-top: 2px solid var(--main_color);
}
.child2 {
  border-top: 2px solid var(--secondary_color);
}
.separator {
  float: left;
  width: 30px;
  opacity: 0;
}
.selected {
  background-color: var(--secondary_color) !important;
}
#file {
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 50px;
}

.back {
  background: url(/img/left-arrow.svg) no-repeat left center;
  text-align: left;
  margin-bottom: 20px;
  padding-left: 25px;
  cursor: pointer;
}
.container {
  width: 100%;
  overflow: hidden;

  .image {
    width: 40%;
    float: left;
    padding: 0 40px;

    img {
      width: 95%;
    }
  }

  .content {
    width: 100%;
    float: left;
    text-align: left;
    padding: 0 25px;

    .title {
      margin: 10px 0;
      font-size: 20pt;
      font-family: Speedee-Bold;
    }
    .details {
      margin: 20px 0;

      .subtitle {
        font-family: Speedee-Bold;
        color: #bbb;
        margin-bottom: 10px;
      }
      .item {
        font-size: 11pt;

        .label {
          margin-right: 5px;
        }
        .value {
          font-family: Speedee-Bold;
        }
      }
    }

    .buttons {
      margin: 35px 0;

      .bttn {
        width: 100%;
        max-width: 300px;
        overflow: hidden;
        margin-bottom: 5px;
        line-height: 30px;
        cursor: pointer;
        display: block;
        color: #333;

        .icon {
          width: 30px;
          height: 30px;
          background: #ccc;
          display: inline-block;
          float: left;
          overflow: hidden;
        }
        span {
          display: inline-block;
          float: left;
          padding-left: 5px;
          font-size: 11pt;

          &:hover {
            font-family: Speedee-Bold;
          }
        }
        &.download {
          border-top: 2px solid var(--main_color);

          .icon {
            background: url(/img/download.svg) no-repeat center
              var(--main_color);
            background-size: 18px;
          }
        }
        &.order {
          border-top: 2px solid #ccc;
          .icon {
            background: url(/img/edit.svg) no-repeat center #ccc;
            background-size: 18px;
          }
        }
      }
    }
    .desc {
      font-size: 10pt;
      margin-top: 25px;
      margin-bottom: 5px;
      display: block;
    }
    .url {
      width: 100%;
      padding: 5px;
      font-size: 11pt;
      border-radius: 5px;
      border: 1px solid #ccc;
    }
  }
}

.searcher {
  padding-top: 0px;
  margin-top: 0px;

  .v-input {
    margin-top: 0px;
    padding-top: 0px;
  }
}
</style>
